<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.auditStatus"
          placeholder="审核状态"
        >
          <el-option
            v-for="(item, i) in auditStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          prefix-icon="el-icon-search"
          v-model="filters.deptName"
          placeholder="报名部门名称"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!showMore" class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      roleData: [],
      auditStatusData: [],
      sexData: [],
      leaderTypeData: [],
      publicData: [],
      showMore: false,
    };
  },
  created() {
    this.getSysParamByTypes([
      "AUDIT_STATUS"
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["AUDIT_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusData = res.data["AUDIT_STATUS"];
      });
    },
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: left;
  border-bottom: 1px dashed #ebeef5;
  margin-bottom: 20px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  & /deep/ .date-picker {
    width: 240px;
  }
  /deep/ .credit-input {
    // width: 160px;
    border-radius: 2px;
    // border: 1px solid #dcdfe6;
    height: 30px;
    color: #606266;
    outline: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    background-image: none;
    // padding: 0 10px;
    &:focus {
      border-color: #3a85ff;
    }
  }
  .sepertor {
    margin: 0 10px;
  }
}
</style>
